import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import ShopBySegment from "../components/ShopBySegment";
import InstagramFeed from "../components/InstagramFeed";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#segments") {
      const el = document.getElementById("segments");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main>
      <Hero />
      <ShopBySegment />
      <InstagramFeed />
    </main>
  );
};

export default Home;
